// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hcRV","buttons":"styles_buttons__aF9Ep"};